export default "__VITE_ASSET__DPyEUnJu__"